import { useState, useEffect } from "react";
import {
  AddAdherenseStyle,
  AddAdherenseTitle,
  WrapContent,
  WrapTitleAndSmallText,
  BackButton,
  SelectContractText,
  GridContainer,
  GridButtons,
  AcceptButton,
  Observation,
} from "../../styles/AddAdherense";
import { useNavigate } from "react-router-dom";
import { ALLADHERENSE, HOME_LOGGED } from "../../core/app-urls";
import axios from "axios";
import EXCELIMAGE from "../../assets/img/excel.png";
import { getPlansByContract } from "../../data/services/enterprise_service";
import { endpoint } from "../../utils/constants";

interface SelectedFile {
  file: File | null;
  id_categoria: string;
}

export default function AddAdherense() {
  const [selectedFiles, setSelectedFiles] = useState<{
    [key: string]: SelectedFile;
  }>({});
  const [contracts, setContracts] = useState<
    {
      categoria: string;
      id_categoria: string;
      id_contrato: number;
      idContratoCategoria: number;
      valor: string;
      num_contrato: string;
      id_clube: string;
      nome_fantasia: string;
    }[]
  >([]);

  const [resultsList, setResultsList] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchContracts() {
      const response = await getPlansByContract();
      if (response.data) {
        setContracts(
          response.data.planos.map((plano) => ({
            categoria: plano.categoria,
            id_categoria: plano.idCategoria,
            id_contrato: plano.idContrato,
            idContratoCategoria: plano.idContratoCategoria,
            valor: plano.valor,
            num_contrato: plano.num_contrato,
            id_clube: plano.ID_CLUBE,
            nome_fantasia: plano.nome_fantasia,
          }))
        );
      }
    }
    fetchContracts();
  }, []);

  const handleLogout = () => {
    navigate(HOME_LOGGED);
  };

  const downloadFile = () => {
    const link = document.createElement("a");
    link.href = "/subir-teste.xlsx";
    link.download = "subir-teste.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (
    categoria: string,
    id_categoria: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFiles((prev) => ({
        ...prev,
        [categoria]: { file, id_categoria },
      }));
    }
  };

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    console.log(file.toString(), "Dados enviados:");
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${endpoint}/data-upload/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Erro ao enviar arquivo:", error);
      return [];
    }
  };

  const handleUpload = async () => {
    setResultsList([]);
    localStorage.setItem("resultsList", JSON.stringify([]));

    const uploadPromises = Object.entries(selectedFiles)
      .filter(([_, data]) => data.file)
      .map(async ([categoria, data]) => {
        console.log(`Enviando arquivo do plano: ${categoria}...`);
        const result = await uploadFile(data.file!);

        const contratoSelecionado = contracts.find(
          (c) => c.id_categoria === data.id_categoria
        );

        const idContrato = contratoSelecionado?.id_contrato ?? null;

        const idCategoriaNovo =
          contratoSelecionado?.id_categoria ?? null;

        return result.map((item: any) => ({
          ...item,
          Id_Empresa: localStorage.getItem("id"),
          Id_categoria: parseInt(idCategoriaNovo!),
          id_contrato: idContrato,
          id_clube: contratoSelecionado?.id_clube ?? null,
        }));
      });

    const allResults = await Promise.all(uploadPromises);
    const updatedResults = allResults.flat();
    setResultsList(updatedResults);
    localStorage.setItem("resultsList", JSON.stringify(updatedResults));
    console.log(localStorage.getItem("resultsList"));
    navigate(ALLADHERENSE);
  };

  return (
    <AddAdherenseStyle>
      <WrapContent>
        <BackButton onClick={handleLogout}>VOLTAR</BackButton>
        <WrapTitleAndSmallText>
          <AddAdherenseTitle>Inclusão de Adesões</AddAdherenseTitle>
          <p>
            Clique na imagem abaixo (ícone excel) e baixe o modelo de planilha
            para realizar a importação de colaboradores em massa nos planos
            abaixo
          </p>
          <img
            src={EXCELIMAGE}
            alt="Download Excel"
            title="Clique aqui para baixar o modelo"
            onClick={downloadFile}
          />
        </WrapTitleAndSmallText>
        <SelectContractText>
          Clique no plano desejado abaixo para realizar o upload da planilha:
        </SelectContractText>
        <Observation>Obs: Um arquivo por plano</Observation>
        <GridContainer>
          {contracts.map(
            ({
              categoria,
              id_categoria,
              valor,
              nome_fantasia,
              num_contrato,
            }) => (
              <div key={categoria} style={{ textAlign: "center" }}>
                {/* <label>
                  <GridButtons
                    as="div"
                    onClick={() =>
                      document.getElementById(id_categoria)?.click()
                    }
                  >
                    <p>
                      <strong>Plano:</strong> {categoria}
                    </p>
                    <div>
                      <strong>Unidade:</strong> {nome_fantasia}
                    </div>
                    <div>
                      <strong>Número do contrato:</strong> {num_contrato}
                    </div>

                    <h5>R$ {valor},00</h5>

                    <input
                      id={id_categoria}
                      type="file"
                      accept=".csv, .xlsx"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileChange(categoria, id_categoria, e)
                      }
                    />
                  </GridButtons>
                </label> */}
                <label htmlFor={id_categoria}>
                  <GridButtons as="div">
                    <p>
                      <strong>Plano:</strong> {categoria}
                    </p>
                    <div>
                      <strong>Unidade:</strong> {nome_fantasia}
                    </div>
                    <div>
                      <strong>Número do contrato:</strong> {num_contrato}
                    </div>

                    <h5>R$ {valor},00</h5>
                  </GridButtons>

                  <input
                    id={id_categoria}
                    type="file"
                    accept=".csv, .xlsx"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleFileChange(categoria, id_categoria, e)
                    }
                  />
                </label>

                {selectedFiles[categoria]?.file && (
                  <p>{selectedFiles[categoria]?.file?.name}</p>
                )}
              </div>
            )
          )}
        </GridContainer>

        <AcceptButton onClick={handleUpload}>
          Continuar / Incusão individual
        </AcceptButton>
      </WrapContent>
    </AddAdherenseStyle>
  );
}
